var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchipelagosLabsQuotesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 50",
    style: {
      enableBackground: "new 0 0 80 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#0EACF6;}\n\t.st3{font-family:'Poppins-SemiBold';}\n\t.st4{font-size:172px;}\n\t.st5{letter-spacing:1;}\n\t.st6{display:inline;fill:#0EACF6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000052789842518537536000000014476738908955002554_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "quote"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1.898734e-02 123.252)",
    className: "st2 st3 st4 st5"
  }, "\u201C"))), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M23.9,3.2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "40.6,3.2 30.8,46.5 5.4,46.5 23.9,3.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "58.7,3.2 75.4,3.2 65.6,46.5 40.1,46.5  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchipelagosLabsQuotesIcon);
export default __webpack_public_path__ + "static/media/Archipelagos_Labs-QuotesIcon.b96f4f2ab1229df1e7bdb855c16badeb.svg";
export { ForwardRef as ReactComponent };